import { AnimatePresence, motion } from "motion/react";
import { HideShowVariant } from "./variants";
import { CSSProperties } from "react";
import styled from "styled-components";

interface StepsTransitionProps {
  components: JSX.Element[] | { [key: string]: JSX.Element };
  stepOrTab: number | string;
  direction?: number;
  style?: CSSProperties;
  wrapWithRelative?: boolean;
}

const HideShowTransition = ({
  components,
  stepOrTab,
  direction = 1,
  style,
  wrapWithRelative,
}: StepsTransitionProps) => {
  const animatedDiv = (
    <motion.div
      custom={direction}
      key={stepOrTab}
      variants={HideShowVariant(8, 3)}
      initial="enter"
      animate="center"
      exit="exit"
      style={{
        position: "absolute",
        ...style,
      }}
      transition={{ type: "spring", damping: 20, mass: 0.55, stiffness: 200 }}
    >
      {/*@ts-ignore*/}
      {components[stepOrTab]}
    </motion.div>
  );

  return (
    <AnimatePresence initial={false} mode="wait" custom={direction}>
      {wrapWithRelative ? <Wrapper>{animatedDiv}</Wrapper> : animatedDiv}
    </AnimatePresence>
  );
};

export default HideShowTransition;

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;
